import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import i18n from 'i18next';
import { RegisterLinkRegisterLinkCreateData, RegisterLinkRegisterLinkDestroyData, RegisterLinkRegisterLinkRetrieveData,
  RegisterLinkRegisterLinkListData, RegisterLinkRegisterLinkUpdateData } from "../api/types.gen";
import { TagService, RegisterLinkService } from "../api/services.gen";
import { TYPE_MAP } from '../constants/index';
import { resetAppState } from "../store/common";

export const getTalentRegisterLinks = createAsyncThunk(
    "getTalentRegisterLinks",
    async (data: RegisterLinkRegisterLinkListData, thunkAPI: any) => {
        try {
            const res: any = await RegisterLinkService.registerLinkRegisterLinkList(data);
            if (res.results) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);
export const createTalentRegisterLink = createAsyncThunk(
    "createTalentRegisterLink",
    async (data: RegisterLinkRegisterLinkCreateData, thunkAPI: any) => {
        try {
            const res: any = await RegisterLinkService.registerLinkRegisterLinkCreate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);

export const getTalentRegisterLinkDetail = createAsyncThunk(
    "getTalentRegisterLinkDetail",
    async (data: RegisterLinkRegisterLinkRetrieveData, thunkAPI: any) => {
        try {
            const res: any = await RegisterLinkService.registerLinkRegisterLinkRetrieve(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);

export const updateTalentRegisterLink = createAsyncThunk(
    "updateTalentRegisterLink",
    async (data: RegisterLinkRegisterLinkUpdateData, thunkAPI: any) => {
        try {
            const res: any = await RegisterLinkService.registerLinkRegisterLinkUpdate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);

export const deleteTalentRegisterLink = createAsyncThunk(
    "deleteTalentRegisterLink",
    async (data: RegisterLinkRegisterLinkDestroyData, thunkAPI: any) => {
        try {
            const res: any = await RegisterLinkService.registerLinkRegisterLinkDestroy(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);


// ========================Tags API========================
export const getTalentTags = createAsyncThunk(
    "getTalentTags",
    async (data: TagTalentTagListData, thunkAPI: any) => {
        try {
            const res: any = await TagService.tagTalentTagList(data);
            if (res.results.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
        }
    },
);

const initTableHeaders = [
  { title: "登録リンクコード", isSort: false, currentSortState: 0, field: "code", width: 'w-[102px]' },
  { title: "種別", isSort: true, currentSortState: 0, field: "talent_role__label", width: 'w-[124px]' },
  { title: "タグ", isSort: false, currentSortState: 0, field: "trl_tags", width: 'w-[224px]' },
  { title: "説明", isSort: false, currentSortState: 0, field: "description", width: 'w-[354px]' },
  { title: "タレント登録数", isSort: true, currentSortState: 0, field: "number_registration", width: 'w-[104px]' },
  { title: "発行日", isSort: true, currentSortState: 1, field: "public_date", width: 'w-[92px]' },
  { title: "ステータス", isSort: true, currentSortState: 0, field: "is_enable_link", width: '' },
  { title: "", isSort: false, currentSortState: 0, width: 'w-[74px]' },
];

export type TalentRegisterLink = {
  id: number;
  code: string;
  link: string;                // thêm link
  attribute: null;
  tags: string[];
  description: string;
  number_of_talents: number;
  issue_date: string;
  status: string; // 有効 / 無効
};
type AttributeOption = { id: number; name: string };

type FormData = {
  attribute: AttributeOption | null;
  tags: string[];
  explanation: string;
  is_link_enabled: boolean;
};

type State = {
  registerLinkList: TalentRegisterLink[];
  formData: FormData;
  selectedRecord: TalentRegisterLink | null;
  mode: "create" | "edit" | "view";
  loading: boolean;
  error: string | null;
  success: string | null;
  countItems: number;
  currentPage: number;
  pageSize: number;
  sortBy: string | null;
  sortOrder: string | null;
  talentTagsList: any;
  talentTagsPanelState: any;
  hasMore: boolean,
  currentPageTagsList: number,
  pageSizeTagsList: number,
  tableHeaders: TableHeader[],
  searchQuery: string | null,
};

const initialState: State = {
  loading: false,
  error: null,
  success: null,
  registerLinkList: [],
  formData: {
    attribute: null,
    tags: [],
    explanation: "",
    is_link_enabled: true,
  },
  selectedRecord: null,
  mode: "create",
  countItems: 0,
  currentPage: 1,
  pageSize: 10,
  sortBy: "public_date",
  sortOrder: "desc",
  talentTagsList: [],
  talentTagsPanelState: [],
  hasMore: false,
  currentPageTagsList: 1,
  pageSizeTagsList: 15,
  tableHeaders: initTableHeaders,
  searchQuery: "",
};

const sortingStates = ["default", "desc", "asc"];

const slice = createSlice({
  name: "talentRegisterLink",
  initialState,
  reducers: {
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setMode(state, action: PayloadAction<"create" | "edit" | "view">) {
      state.mode = action.payload;
    },
    setCurrentPageTagsList: (state, action) => { state.currentPageTagsList = action.payload; },
    selectRecord(state, action) { state.selectedRecord = action.payload; },
    setTalentTagsList(state, action) { state.talentTagsList = action.payload; },
    updateFormData(state, action: PayloadAction<Partial<FormData>>) {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetForm: (state, action) => { 
      state.formData = {
        attribute: null,
        tags: [],
        explanation: "",
        is_link_enabled: true,
      };
      state.talentTagsPanelState = [];
    },
    updateTalentTagSelected: (state, action) => {
      const { id, tag } = action.payload;
      const existsSelected = state.formData.tags.some((t: any) => t.id === id);

      if (existsSelected) {
        state.formData.tags = state.formData.tags.filter((t: any) => t.id !== id);
      } else {
        const found = tag || state.talentTagsPanelState.find((t: any) => t.id === id);
        if (found) {
          state.formData.tags = [...state.formData.tags, found];
        }
      }

      state.talentTagsPanelState = state.talentTagsPanelState.map((t: any) =>
        t?.id === id ? { ...t, selected: !existsSelected } : t
      );
    },
    handleSortByHeader(state, action) {
      const sortHeader = action.payload;
      state.tableHeaders = state.tableHeaders.map((header, idx) => (header.field === sortHeader.field)
      ? ({...header, currentSortState: (header.currentSortState + 1) % sortingStates.length})
      : ({...header, currentSortState: 0}));
      
      if((sortHeader.currentSortState + 1) % sortingStates.length !== 0) {
          state.sortBy = sortHeader.field;
          state.sortOrder = sortingStates[(sortHeader.currentSortState + 1) % sortingStates.length];
      } else {
          state.sortBy = null;
          state.sortOrder = null;
      }
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    // reset state
    .addCase(resetAppState, () => initialState)

    // getTalentRegisterLinks
    .addCase(getTalentRegisterLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(getTalentRegisterLinks.fulfilled, (state, action) => {
        state.loading = false;
        state.registerLinkList = action.payload.results ? action.payload.results : [];
        state.countItems = action.payload.count;
    })
    .addCase(getTalentRegisterLinks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    // createTalentRegisterLink
    .addCase(createTalentRegisterLink.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(createTalentRegisterLink.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload?.message || "";
    })
    .addCase(createTalentRegisterLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    // updateTalentRegisterLink
    .addCase(updateTalentRegisterLink.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(updateTalentRegisterLink.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
    })
    .addCase(updateTalentRegisterLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    // deleteTalentRegisterLink
    .addCase(deleteTalentRegisterLink.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(deleteTalentRegisterLink.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.isReload = !state.isReload;
    })
    .addCase(deleteTalentRegisterLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    // getTalentRegisterLinkDetail
    .addCase(getTalentRegisterLinkDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(getTalentRegisterLinkDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        if(action.payload?.data) {
          const {data} = action.payload;
          const type = TYPE_MAP[data?.talent_role?.value];
          const newLink = `${window.location.origin}/new/${type}/_url_slug_?c=${data?.code}`;
          
          state.selectedRecord = {
            ...data,
            link: newLink
          };
          state.formData = {
            tags: data?.trl_tags.map((tag, idx) => ({id: tag?.id, title: tag?.tag?.title})),
            explanation: data?.description,
            is_link_enabled: data?.is_enable_link,
          }
        }
    })
    .addCase(getTalentRegisterLinkDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })

    // getTalentTags
    .addCase(getTalentTags.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.hasMore = false;
    })
    .addCase(getTalentTags.fulfilled, (state, action) => {
      state.loading = false;
      const { page } = action.meta.arg;
      const list = action.payload?.results?.data || [];
      const total = action.payload?.count ?? 0;

      const existingMap = new Map(state.talentTagsPanelState.map(tag => [tag.id, tag]));

      const fetched = list.map(tag => {
        const old = existingMap.get(tag.id);
        return old ? { ...tag, selected: old.selected } : { ...tag, selected: false };
      });

      if (page === 1) {
        state.talentTagsPanelState = fetched;
      } else {
        state.talentTagsPanelState = [...state.talentTagsPanelState, ...fetched];
      }

      const selectedExtra = state.talentTagsPanelState.filter(tag => tag.selected);
      const selectedIds = new Set(selectedExtra.map(t => t.id));

      state.talentTagsPanelState = [
        ...state.talentTagsPanelState,
        ...[...existingMap.values()].filter(t => t.selected && !selectedIds.has(t.id))
      ];

      state.talentTagsPanelState.sort((a, b) => {
        if (a.selected === b.selected) return a.title.localeCompare(b.title);
        return a.selected ? -1 : 1;
      });

      state.hasMore = state.talentTagsPanelState.length < total;
    })

    .addCase(getTalentTags.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
  }
});

export const { 
  setMode, selectRecord, updateFormData, submitForm, setSuccess, setError, setCurrentPage, 
  setCurrentPageTagsList, setTalentTagsList, updateTalentTagSelected, resetForm, handleSortByHeader, setSearchQuery
} = slice.actions;

export default slice.reducer;
